import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';
function ReservesWaterfallChartSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-60 w-full md:h-70 xl:h-90" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex w-full flex-col gap-3">{t0}<div className="flex justify-center gap-4 md:gap-8"><Skeleton className="h-5 w-30" /><Skeleton className="h-5 w-20" /><Skeleton className="h-5 w-20" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export { ReservesWaterfallChartSkeleton };